module.exports = __webpack_public_path__ + "media/torta.2c361445.webm";